import { Flex, Link } from '@chakra-ui/react';
import React from 'react';
import { Website } from '../../service/social';
import { DiscordIconSmall } from '../iconComponents/DiscordIconSmall';
import { FacebookIconSmall } from '../iconComponents/FacebookIconSmall';
import { TwitchIconSmall } from '../iconComponents/TwitchIconSmall';
import { TwitterIconSmall } from '../iconComponents/TwitterIconSmall';
import { YoutubeIconSmall } from '../iconComponents/YoutubeIconSmall';

interface GameSocialProps {
    websites: Website[];
}

const facebookCategory: number = 4;
const twitterCategory: number = 5;
const twitchCategory: number = 6;
const youtubeCategory: number = 9;
const discordCategory: number = 18;

export const GameSocials: React.FC<GameSocialProps> = ({ websites }) => {
    const getWebsiteIcon = (website: Website) => {
        switch (website.category) {
            case facebookCategory:
                return FacebookIconSmall();
            case twitterCategory:
                return TwitterIconSmall();
            case twitchCategory:
                return TwitchIconSmall();
            case youtubeCategory:
                return YoutubeIconSmall();
            case discordCategory:
                return DiscordIconSmall();
        }

        return undefined;
    };

    return (
        <Flex className={'game-socials'}>
            {websites.map(
                (website, idx) =>
                    getWebsiteIcon(website) !== undefined && (
                        <Link key={idx} href={website.url} target={'_blank'}>
                            {getWebsiteIcon(website)}
                        </Link>
                    ),
            )}
        </Flex>
    );
};
